import { API } from 'core';
import { ServerRoute } from 'core/api';

export class CmePassportImpersonationService {
  public static async getImpersonationToken(email: string): Promise<string> {
    const route: ServerRoute = ServerRoute.forAction('Users', 'generate-cmepassport-token');
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    return await API.post(route, email, config);
  }
}
